import { US_STATES_LIST } from '../constants'

const statesNameValueMap = new Map([
  ...US_STATES_LIST.map(state => {
    return [state.label.toLowerCase(), state.value]
  })
])
const statesAbbreviationValueMap = new Map([
  ...US_STATES_LIST.map(state => {
    return [state.value.toLowerCase(), state.value]
  })
])
const getStateFromName = name => {
  const filtered = US_STATES_LIST.filter(
    state => state.label.toLowerCase() === name?.toLowerCase()
  )

  if (filtered.length) {
    return filtered[0]
  }
}
const getStateFromAbbreviation = abbr => {
  const filtered = US_STATES_LIST.filter(
    state => state.value.toLowerCase() === abbr?.toLowerCase()
  )

  if (filtered.length) {
    return filtered[0]
  }
}
const parseStateValueFromCustomInput = val =>
  statesNameValueMap.get(val?.trim().toLowerCase()) ??
  statesAbbreviationValueMap.get(val?.trim().toLowerCase())

export {
  statesNameValueMap,
  statesAbbreviationValueMap,
  getStateFromAbbreviation,
  getStateFromName,
  parseStateValueFromCustomInput
}
